import { useMemo } from 'react';
import { Grid, Stack } from '@mui/material';
import { useLayoutComponentSettings } from '@diana/core';
import { ComponentsListItem } from './ComponentsListItem';

export const ComponentsList = () => {
  const { getAllSettings } = useLayoutComponentSettings();

  const settings = useMemo(() => {
    return getAllSettings();
  }, [getAllSettings]);

  return (
    <Stack gap={1} sx={{ height: '100%', overflowY: 'auto' }}>
      <Grid container spacing={1}>
        {Object.values(settings).map(([name, settings], index) => {
          if (settings?.hidden) return null;
          return (
            <Grid key={`flow-builder-component-list-item-${index}`} item xs={6} display="flex">
              <ComponentsListItem name={name} settings={settings} />
            </Grid>
          );
        })}
      </Grid>
    </Stack>
  );
};
